module.exports = {
	"data": {
		"allFile": {
			"edges": [
				{
					"node": {
						"relativePath": "community/articles-and-videos.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Articles & Videos",
								"order": 10
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/blog.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Blog",
								"order": 0
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/companies.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Companies",
								"order": 60
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/events.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Events",
								"order": 30
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/examples.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Examples",
								"order": 20
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/faq.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Frequently Asked Questions",
								"order": 40
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/index.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Community",
								"order": 0
							}
						}
					}
				},
				{
					"node": {
						"relativePath": "community/roadmap.md",
						"childMarkdownRemark": {
							"frontmatter": {
								"title": "Roadmap & Contribution",
								"order": 50
							}
						}
					}
				}
			]
		},
		"file": {
			"relativePath": "community/events.md",
			"childMarkdownRemark": {
				"html": "<p>There are a few Reason meetups around the world, among others:</p>\n<ul>\n<li><a href=\"https://www.meetup.com/Reason-Vienna/\">Vienna</a> (<a href=\"https://twitter.com/reasonvienna\">Twitter</a>)</li>\n<li><a href=\"https://www.meetup.com/Chicago-ReasonML/\">Chicago</a></li>\n<li><a href=\"https://www.meetup.com/sv-ocaml/\">San Francisco</a></li>\n<li><a href=\"https://www.meetup.com/SG-OCaml/\">Singapore</a></li>\n<li><a href=\"https://www.meetup.com/got-lambda/\">Göteborg</a></li>\n<li><a href=\"https://www.meetup.com/ReasonML-NYC/\">New York</a> (<a href=\"https://twitter.com/nycreasonml\">Twitter</a>)</li>\n<li><a href=\"https://www.meetup.com/reason-sydney/\">Sydney</a></li>\n<li><a href=\"https://www.meetup.com/ReasonML-Paris/\">Paris</a></li>\n<li><a href=\"https://www.meetup.com/ReasonMTL/\">Montreal</a></li>\n<li><a href=\"https://www.meetup.com/ReasonLDN/\">London</a> (<a href=\"https://twitter.com/reasonldn\">Twitter</a>)</li>\n<li><a href=\"https://www.meetup.com/Reason-Oslo/\">Oslo</a> (<a href=\"http://twitter.com/reasonoslo/\">Twitter</a>)</li>\n<li><a href=\"https://www.meetup.com/Portland-ReasonML/\">Portland</a> (<a href=\"https://twitter.com/ReasonPDX\">Twitter</a>)</li>\n<li><a href=\"https://www.meetup.com/preview/ReasonML-CPH\">Copenhagen</a></li>\n<li><a href=\"https://www.meetup.com/ReasonML-BXL/\">Brussels</a></li>\n<li><a href=\"https://www.meetup.com/ReasonML-Budapest/\">Budapest</a></li>\n</ul>\n<p>If you don't find your local area's Reason meetup, search on <a href=\"https://meetup.com\">https://meetup.com</a> or start one!</p>",
				"frontmatter": {
					"title": "Events"
				}
			}
		}
	},
	"pathContext": {
		"section": "community",
		"sectionTitle": "Community",
		"relativePath": "community/events.md",
		"relatedFiles": "/^community\\/.*\\.md$/"
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/community-events.json
// module id = ./node_modules/json-loader/index.js!./.cache/json/community-events.json
// module chunks = 59